export const LARGE_BREAKPOINT = 600;
export const MEDIUM_BREAKPOINT = 320;
export const LINK_HREF = 'https://www.atlassian.com/trust/atlassian-intelligence';
